export enum DatasetDeletionMode {
  delete,
  deprovision,
  replace,
}
